// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1xGlv","radioRow":"SimpleQuestionBuilderModal_radioRow__13XYR"};